import { TileContainer as Container } from "src/components/tile/TileContainer";
import { Tile } from "src/components/tile/Tile";

export const Tiles = {
    Tile,
    Container,
};